import "./langFetchPatch";
import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";
import AppRoutes from "./routes";
import { CartProvider } from "./contexts/CartContext";
import { Elements } from "@stripe/react-stripe-js";
import { LoadScript } from "@react-google-maps/api";
import { loadStripe } from "@stripe/stripe-js";
import { LoadingProvider } from "./contexts/LoadingContext";

import "./datepicker.css";
function App() {
  const libraries = ["places"];
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY || ""
  );

  if (!process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
    console.error("Google Maps API key is missing");
  }

  return (
    <LoadingProvider>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
        libraries={libraries}
        onError={(error) => console.error("Google Maps loading error:", error)}
      >
        <Elements stripe={stripePromise}>
          <AuthProvider>
            <CartProvider>
              <AppRoutes />
            </CartProvider>
          </AuthProvider>
        </Elements>
      </LoadScript>
    </LoadingProvider>
  );
}

export default App;
